import { Button, Col, Form, Grid, Input, notification, Row, Spin } from 'antd';
import * as Api from 'api';
import config from 'api/config';
import bgAuth from 'assets/image/bg-auth.jpg';
import logoPng from 'assets/image/hunt_control_logo.png';
import React, { useEffect, useState } from 'react';
import useAuth from 'redux/auth/auth.hook';
import history from 'redux/history';
import { PATHS } from 'res/routes';
import storage from 'store';
import classes from './style.module.scss';

const { useBreakpoint } = Grid;

const AuthResetPassword = () => {
  const { md } = useBreakpoint();
  const { auth } = useAuth();
  const [loading, setLoading] = useState(false);

  const onFinish = (values: any) => {
    console.log('onFinish ====>', values);

    setLoading(true);
    Api.AUTH_PASSWORD_REQUEST({ email: values.email }).then(((res: any) => {
      setLoading(false);
      const result = JSON.parse(res.text);
      if (result.data.status == 200) {
        storage.set('reset_email', values.email);
        history.push(PATHS.AUTH_RESET_EMAIL_SENT);
      } else {
        notification.open({
          message: result.message,
        });
      }
    })).catch((error: any) => {
      setLoading(false);
      console.log('error ===>', error);
    });
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  useEffect(() => {
    if (auth.profile) {
      history.push(PATHS.HOME);
    }
  }, [auth.profile]);

  return (
    <Row className={classes.authWrapper}>
      {md && (
        <Col md={8}>
          <div className={classes.leftSide}>
            <img className={classes.authBg} src={bgAuth} alt="" />
            <div className={classes.logoWrapper}>
              <img src={logoPng} alt="" />
              <h1>HuntControl</h1>
            </div>

          </div>
        </Col>
      )}
      <Col md={16} xs={24}>
        <div className={classes.rightpanel}>
          <div className={classes.signupFormHeader}>
            <span>Already have an account?</span>
            <a href="/signin">Sign in</a>
          </div>
          <div className={classes.siginFormWrapper}>
            <Spin spinning={loading} size="large">
              <Form initialValues={{ remember: true }} onFinish={onFinish} onFinishFailed={onFinishFailed}>
                <div className={classes.formWrapper} style={{ width: md ? 500 : 300 }}>
                  <h4>Reset your password</h4>
                  <span>Enter the email address associated with your account and we’ll send you a verify code.</span>
                  <h3>Email</h3>
                  <Form.Item name="email" rules={[{ required: true, message: 'Please input your email!' }]}>
                    <Input size="large" />
                  </Form.Item>
                  <Form.Item>
                    <Button className={classes.btnSignin} htmlType="submit" size="large">
                      Continue
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </Spin>
          </div>
        </div>
      </Col>
    </Row>
  );
};
export default AuthResetPassword;
